import { invoiceService } from '../../services'
import { getField, updateField } from 'vuex-map-fields';

const state = {
  selectedInvoice:null,
  loading: false,
  newInvoiceData:null,
  selectedSupplier:null,
  payment:{
    inout:null,
    method:null,
    description:null,
    amount:null
  }
}

const actions = {
  getInvoice ({ commit,dispatch }, invoiceId) {
    commit('getInvoiceRequest')
    return invoiceService.getInvoiceById(invoiceId)
      .then(
        cities => {
          commit('getInvoiceSuccess', cities)
          dispatch('customers/selectCustomer',cities.customer,{root:true})
          return cities
        },
        error => commit('getInvoiceFailure', error)
      )
  },

  getLocator ({ commit  }, locatorId){
    commit('getInvoiceRequest')
    return invoiceService.getLocatorById(locatorId)
    .then (
      invoice => {
        commit('getInvoiceSuccess' , invoice)      
        return invoice
      },
      error => commit('getInvoiceFailure' ,error)
    )
  },

  getVendorLocator ({ commit }, vendorLocatorId){
    commit ('getInvoiceRequest')
    return invoiceService.getVendorLocatorById(vendorLocatorId)
    .then (
      invoice =>{ 
        commit('getInvoiceSuccess' , invoice)
        return invoice
      },
      error => commit ('getInvoiceFailure' , error)
    )
  },

  updateSabreInvoiceData ({ commit},sabreInvoiceData) {    
    commit('updateSabreInvoiceDataRequest',sabreInvoiceData)
  },

  updateBtresInvoiceData ({ commit},btresInvoiceData) {    
    commit('updateBtresInvoiceDataRequest',btresInvoiceData)
  },

  updateTkConnectInvoiceData ({ commit},tkConnectInvoiceData) {    
    commit('updateTkConnectInvoiceDataRequest',tkConnectInvoiceData)
  },

  updateEmiratesInvoiceData ({ commit }, emiratesData) {
    commit('updateEmiratesInvoiceDataRequest', emiratesData)
  },

  createNewInvoiceService({ commit }, {customer,invoice,payment,flights,passengers,supplier,services,sendSms}) {
    commit('createInvoiceRequest')
    return invoiceService.createInvoice(customer,invoice,payment,flights,passengers,supplier,services,sendSms)
      .then(
        response => {
          commit('createInvoiceSuccess', response)          
          return response 
        },
        error => {          
          return Promise.reject(error)
        }
      )
  },
  updateInvoiceService({ commit }, {customer,invoice,payment,flights,passengers,supplier,services}) {
    commit('createInvoiceRequest')
    return invoiceService.updateInvoice(customer,invoice,payment,flights,passengers,supplier,services)
      .then(
        response => {
          commit('updateInvoiceSuccess', response)          
          return response 
        },
        error => commit('updateInvoiceFailure', error)
      )
  },
  //new invoice commits addition
  newInvoice ({ commit, rootState }) {
    commit('newInvoice', rootState.settings.defaultInvoiceNotes)  
  },
  updateSelectedSupplier ({ commit },supplier) {
    commit('updateSelectedSupplier',supplier)  
  },
  updateDiscount ({ commit },discount) {
    commit('updateDiscount',discount)  
  },
  updateAToL ({ commit },aToL) {
    commit('updateAToL',aToL)  
  },
  updatePassengersData ({ commit},passengersData) {    
    commit('updateInvoicePassengersDataRequest',passengersData)
  },  
  updateServicesData ({ commit},servicesData) {    
    console.log("updateServicesData")
    commit('updateInvoiceServicesDataRequest',servicesData)
  },  
  updatePayment ({ commit},paymentData) {    
    console.log("updatePayment")
    console.log(paymentData)
    commit('updatePayment',paymentData)
  },  
  updateFlightData ({ commit},flightData) {    
    commit('updateInvoiceFligthsDataRequest',flightData)
  }
}
  

export const invoice = {
  getters: {
    getField,
  },
  mutations: {
    updateField,
    newInvoice (state, defaultNotes) {      
      let today = new Date().toISOString().slice(0, 10)

      state.selectedInvoice = {
        id:null,        
        locator:"",
        createdAt:today,
        aToL:0,
        bookingFee:0,
        discount:0,
        description: defaultNotes ? defaultNotes : "" //acept notes updated
      };
    },
    getInvoiceRequest (state) {
      state.loading = true
    },
    getInvoiceSuccess (state, invoice) {
      state.selectedInvoice = invoice
      state.selectedInvoice['fromServer']=true
      state.selectedSupplier = JSON.parse(JSON.stringify(invoice.supplier))
      state.loading = false
    },
    
    updateDiscount (state, val) {
      state.selectedInvoice.discount = parseFloat(val)
      state.selectedInvoice=JSON.parse(JSON.stringify(state.selectedInvoice))      
    },
    updateAToL (state, val) {
      state.selectedInvoice.aToL = parseFloat(val)
      state.selectedInvoice=JSON.parse(JSON.stringify(state.selectedInvoice))      
    },
    getInvoiceFailure (state, error) {
      state.selectedInvoice = { error }
    },
    createInvoiceRequest (state) {
      state.loading = true
    },
    createInvoiceSuccess (state, invoice) {
      state.selectedInvoice = invoice
      state.loading = false
    },
    createInvoiceFailure (state, error) {
      state.selectedInvoice = { error }
    },
    updateInvoiceSuccess (state, invoice) {
      state.selectedInvoice = invoice
      state.selectedSupplier = JSON.parse(JSON.stringify(invoice.supplier))            
      state.selectedInvoice['fromServer']=true
      state.loading = false
    },
    updateInvoiceFailure (state, error) {
      state.selectedInvoice = { error }
    },
    addNewCityRequest (state) {
      state.loading = true
    },
    updateSelectedSupplier (state, supplier) {      
      state.selectedSupplier = supplier
    },
    updateSelectedInvoice (state, message) {
      console.log(message)
      state.invoice = message
    },
    updatePayment (state, payment) {      
      state.payment = payment
    },
    updateInvoicePassengersDataRequest (state, invoiceData) {    
      state.selectedInvoice.passengers = invoiceData
      state.selectedInvoice=JSON.parse(JSON.stringify(state.selectedInvoice))
    },
    updateInvoiceServicesDataRequest (state, invoiceData) {    
      state.selectedInvoice.services = invoiceData
      state.selectedInvoice=JSON.parse(JSON.stringify(state.selectedInvoice))
    },
    updateInvoiceFligthsDataRequest (state, invoiceData) {      
      state.selectedInvoice.flights = invoiceData
      state.selectedInvoice=JSON.parse(JSON.stringify(state.selectedInvoice))
    },
    updateSabreInvoiceDataRequest(state, invoiceData) {
      state.selectedInvoice.flights=invoiceData.flights;
      state.selectedInvoice.passengers=invoiceData.passengers;
      state.selectedInvoice.vendLoc=invoiceData.locator;
      state.selectedInvoice.locator=invoiceData.vendorLocator;
      state.selectedInvoice.gds = "Sabre";
      state.selectedInvoice=JSON.parse(JSON.stringify(state.selectedInvoice))
    },
    updateBtresInvoiceDataRequest(state, invoiceData) {
      state.selectedInvoice.flights=invoiceData.flights;
      state.selectedInvoice.passengers=invoiceData.passengers;
      state.selectedInvoice.vendLoc=invoiceData.locator;
      state.selectedInvoice.locator=invoiceData.vendorLocator;
      state.selectedInvoice.aToL = invoiceData.atol || 0;
      state.selectedInvoice.bookingFee = invoiceData.bookingFee || 0;
      state.selectedInvoice.gds = "BTRES";
      state.selectedInvoice=JSON.parse(JSON.stringify(state.selectedInvoice))
    },
    updateTkConnectInvoiceDataRequest(state, invoiceData) {
      state.selectedInvoice.flights     = invoiceData.flights;
      state.selectedInvoice.passengers  = invoiceData.passengers;
      state.selectedInvoice.vendLoc     = invoiceData.locator;
      state.selectedInvoice.locator     = invoiceData.vendorLocator;
      state.selectedInvoice.aToL        = invoiceData.atol || 0;
      state.selectedInvoice.bookingFee  = invoiceData.bookingFee || 0;
      state.selectedInvoice.gds         = "TKCONNECT";
      state.selectedInvoice=JSON.parse(JSON.stringify(state.selectedInvoice))
    },
    updateEmiratesInvoiceDataRequest(state, invoiceData) {
      // Set flights + locator only on first paste (when grid is empty)
      if (!state.selectedInvoice.flights || state.selectedInvoice.flights.length === 0) {
        state.selectedInvoice.flights     = invoiceData.flights;
        state.selectedInvoice.vendLoc     = invoiceData.locator;
        state.selectedInvoice.locator     = invoiceData.vendorLocator;
        state.selectedInvoice.gds         = "EMIRATES";
      }
      // Always APPEND the passenger — allows multi-ticket paste
      if (!state.selectedInvoice.passengers) {
        state.selectedInvoice.passengers = [];
      }
      state.selectedInvoice.passengers = state.selectedInvoice.passengers.concat(invoiceData.passengers);
      state.selectedInvoice = JSON.parse(JSON.stringify(state.selectedInvoice));
    },
    
  },
  namespaced: true,
  state,
  actions,  
}
